export const SEARCH = {
  throttleDuration: 500,
  resultsMaxLength: 10,
};

export const STYLES = {
  infothek: "infothek.css",
};
